import api from '@/apis/di/budgetKindItemAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Khoản
export const useBudgetKindItemComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBudgetKindItemComboboxLoadData = (payload, row, column) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [
      { Field: 'grade', Value: 1 },
      { Field: 'inactive', Value: false, Ors: ors },
    ]; // 1 là Loại
    if (payload.columns && !payload.columns.includes('misa_code_id')) {
      payload.columns += ',misa_code_id';
    }
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'budget_kind_item_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // func call api lấy tất cả dữ liệu combo
  const onBudgetKindItemComboboxLoadAllData = (payload, row, column, customData) => {
    payload.sort = 'misa_code_id';
    payload.columns += ',misa_code_id,inactive';
    payload.take = 3000;
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);
  };

  // config columns combo
  const budgetKindItemComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã loại',
        dataField: 'budget_kind_item_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên loại',
        dataField: 'budget_kind_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_kind_item_code',
    valueField: 'budget_kind_item_code',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onBudgetKindItemComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    budgetKindItemComboConfig,
    onBudgetKindItemComboboxLoadData,
    onBudgetKindItemComboboxLoadAllData,
  };
};
